import { gql } from "@apollo/client";

export const KEY = process.env.REACT_APP_API_TOKEN;

export const GET_REDE_BY_ID = gql`
  query GetRedeById($Id: Int! $token: String!) {
    TipoRedeById(token: $token Id: $Id) {
      id
      nome
    }
  }
`;

export const GET_EQUIPMENTS_BY_REDE = gql`
  query GetEquipmentsByRede($redeId: Int! $token: String!) {
    EquipamentoByRedeID(token: $token Id: $redeId) {
      ID
      Nome
      NATUREZA_JURIDICA
    }
  }
`;

export const GET_EQUIPMENT_BY_ID = gql`
  query GetEquipmentById($Id: Int! $token: String!) {
    EquipamentoByID(token: $token Id: $Id) {
      ID
      Nome
      DistritoNome
      Endereco
      Telefone
      URL
      Descricao
      TipoEquipamentoNome
      TipoRedeId
      TipoRedeNome
      EMAIL
      CELULAR
      ACESSO
      HORARIO
      NATUREZA_JURIDICA
    }
  }
`;

export const GET_FILTERED_EQUIPAMENTOS = gql`
  query GetFilteredEquipments(
    $token: String!
    $distritoId: Int!
    $tipoEquipamento: Int!
    $tipoRede: Int!
    $tipoServico: Int!
    $txtPesquisa: String!
  ) {
    EquipamentoFilter(
      token: $token
      distritoId: $distritoId
      tipoEquipamento: $tipoEquipamento
      tipoRede: $tipoRede
      tipoServico: $tipoServico
      txtPesquisa: $txtPesquisa
    ) {
      ID
      Nome
      TipoRedeId
      TipoServicoId
      TipoServicoNome
      NATUREZA_JURIDICA
    }
  }
`;

export const GET_ALL_DISTRITOS = gql`
  query GetAllDistritos($token: String!) {
    DistritoAll(token: $token) {
      codigo
      nome
    }
  }
`;

export const GET_ALL_REDES = gql`
  query GetAllRedes($token: String!) {
    TipoRedeAll(token: $token) {
      id
      nome
    }
  }
`;

export const GET_ALL_EQUIPAMENTOS = gql`
  query GetAllEquipamentos($token: String!) {
    TipoEquipamentoAll(token: $token) {
      id
      nome
    }
  }
`;

export const GET_SERVICO_BY_REDE = gql`
  query GetServicoByRede(
    $token: String!
    $tipoRede: Int!
  ) 
  {
    ServicoByRedeID(
      token: $token 
      tipoRede: $tipoRede
    ) {
      TipoServicoNome
      TipoServicoID
    }
  }
`;

export const GET_TIPO_SERVICO_BY_ID = gql`
  query GetTipoServicoByID(
    $token: String!
    $Id: Int!
  ) 
  {
    TipoServicoById(
      token: $token 
      Id: $Id
    ) {
      nome
    }
  }
`;
